<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2020-07-28 09:29:22
 * @LastEditors: mrh
 * @LastEditTime: 2020-12-04 09:52:08
--> 
<template>
  <div class="set">
    <van-form>
      <van-uploader
        class="setUnload"
        :after-read="afterRead"
        v-model="setObj.headpic"
        :deletable="false"
        :preview-full-image="false"
      >
        <van-field
          label="头像"
          v-model="setObj.headpic[0].url"
          readonly
          name="headpic"
          placeholder="头像"
          right-icon="arrow"
          input-align="right"
        />
      </van-uploader>
      <van-field
        v-model="setObj.shopName"
        name="shopName"
        label="绑定社区"
        placeholder="绑定社区"
        readonly
        input-align="right"
      />
      <van-field
        v-model="setObj.name"
        label="店长名称"
        placeholder="请填写店长名称"
        right-icon="arrow"
        input-align="right"
        readonly
        @click="showEditPopup('name', 0)"
      />
      <van-field
        v-model="setObj.mobile"
        label="店铺电话"
        type="tel"
        readonly
        clearable
        placeholder="请填写店铺电话"
        right-icon="arrow"
        input-align="right"
        @click="showEditPopup('mobile', 1)"
      />
      <van-field
        v-model="setObj.communitAddress"
        label="社区地址"
        placeholder="请填写社区地址"
        type="textarea"
        autosize
        readonly
        rows="1"
        input-align="right"
      />
      <van-field
        v-model="setObj.address"
        autosize
        label="提货地址"
        placeholder="请填写提货地址"
        right-icon="arrow"
        type="textarea"
        rows="1"
        readonly
        input-align="right"
        @click="showEditPopup('address', 2)"
      />
    </van-form>
    <div class="code">
      <div class="code-title">门店小程序码</div>
      <div class="code-tips">可将此小程序码保存后分享到朋友圈或者微信群</div>
      <div class="code-img">
        <img :src="codeUrl">
      </div>
    </div>
    <van-button
      type="default"
      text="保存"
      class="save-btn"
      @click.stop="save()"
    />
    <van-dialog
      v-model="showEdit"
      show-cancel-button
      @cancel="showEdit = false"
      :beforeClose="beforeClose"
    >
      <van-form
        validate-first
        @failed="onFailed"
        :show-error-message="false"
        scroll-to-error
        @submit="onSubmit"
        ref="submits"
        validate-trigger="onSubmit"
        :show-error="showError"
      >
        <van-field
          v-model="setObj[editObj.name]"
          :type="editObj.name == 'mobile'?'tel':editObj.name == 'address'?'text':'text'"
          :label="editObj.label"
          :placeholder="editObj.placeholder"
          clearable
          :maxlength="editObj.name=='mobile'?'11':'200'"
          :rules="[{ validator: asyncValidator, message: editObj.message }]"
        />
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
import { shopInfo, updateShopInfo, uploadImageBase64 } from "@/api/join";
export default {
  data() {
    return {
      // headPic: "",
      // username: "",
      // houses: "",
      // address: "",
      // address2: "",
      // tel: "",
      setObj: {
        communityShopId: "", //社区店长id
        shopName: "", // 社区店名称，开始同步社区名称
        type: "", // 店长类型，1：正式店长，2：代理店长
        name: "", // 社区店店长名称
        mobile: "", //手机号
        address: "", //详细地址
        communitAddress: "", //社区地址
        headpic: [
          // { url: 'https://img.yzcdn.cn/vant/leaf.jpg' },
        ], //头像url地址
      },
      showError: false,
      fileList: [
        // { url: 'https://img.yzcdn.cn/vant/leaf.jpg' },
        // Uploader 根据文件后缀来判断是否为图片文件
        // 如果图片 URL 中不包含类型信息，可以添加 isImage 标记来声明
        // { url: 'https://cloud-image', isImage: true },
      ],
      minScope: "",
      messages: "请填写送货上门范围",
      showEdit: false, //编辑弹窗展示
      editObj: {
        label: "",
        name: "",
        message: "",
        placeholder: "",
      },
      codeUrl: ""
      // clicks:false,//是否点击保存按钮
    };
  },
  mounted() {
    let baseURL = this.prefixURL || "http://192.168.1.58:8080/app";
    let scene = `${this.$store.getters.memberId},${this.$store.getters.communityShopId}`;
    this.codeUrl = `${baseURL}/comm/2_1/getWXQrcodeOfId?width=402&scene=${scene}&page=pages/bazaarIndex/bazaarIndex`;
    this.shopInfo();
  },
  methods: {
    // 下载二维码
    save() {
      let imgUrl = this.codeUrl, title = "店长二维码", shareType = "3", type = "2";
      if (this.$store.getters.ambientType == 1) {
        // Android环境
        window.Android.shareCommunity(
          imgUrl,
          title,
          shareType,
          type,
          this.$store.getters.communityShopId,
          -1
        );
      } else if (this.$store.getters.ambientType == 2) {
        // ios环境
        /**
         * @param {} imgUrl 分享图路径
         * @param {} title 分享文本
         * @param {} shareType 分享类型 0-商品  1-店铺  2-邀请社区店长注册 3-邀请用户注册 4-排行榜
         * @param {} type  点击类型 0-微信分享 1-微信朋友圈  2-保存图片
         * @param {} communityShopId 店家id
         * @param {} sellerProductGoodsId 商品id
         */
        // window.webkit.messageHandlers.getShare.postMessage
        window.webkit.messageHandlers.shareCommunity.postMessage({
          imgUrl: imgUrl,
          title: title,
          shareType: shareType,
          type: type.toString(),
          communityShopId: this.$store.getters.communityShopId,
          sellerProductGoodsId: -1,
        });
      }
    },
    // 过滤送货上门范围
    formatter(value) {
      // 过滤输入的数字
      return value.replace(/^(\-)*(\d+)\.(\d).*$/, "$1$2.$3");
    },
    // 异步校验函数返回 Promise
    asyncValidator(val, type) {
      return new Promise((resolve) => {
        setTimeout(() => {
          this.$toast.clear();
          if (type.message == "请输入店铺电话") {
            if (val == "" || val == undefined) {
              type.message = `请输入店铺电话`;
              resolve(/^(d*)$/.test(val * 1));
            } else {
              type.message = `请输入正确的手机号`;
              resolve(/^[1][3,4,5,7,8,9][0-9]{9}$/.test(val));
            }
          } else {
            resolve(/\S/.test(val));
          }
          resolve(/\S/.test(val));
        }, 100);
      });
    },
    onSubmit(val) {
      // console.log(val)
      if (this.setObj.headpic[0].url.indexOf(this.imgPrex) != -1) {
        this.setObj.headpic = this.setObj.headpic[0].url.split(this.imgPrex)[1];
      } else {
        this.setObj.headpic = this.setObj.headpic[0].url.split(this.imgPrex)[0];
      }
      if (val != 'uploadPic') {
        this.setObj[Object.keys(val)[0]] = val[Object.keys(val)[0]];
      }
      // console.log(Object.keys(val));
      updateShopInfo(this.setObj).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.$toast({
            duration: 1000, // 持续展示 toast
            message: '修改成功',
          });
          this.showEdit = false;
          this.shopInfo()
          // setTimeout(() => {
          //   if (this.$store.getters.ambientType == 0) {
          //     wx.miniProgram.navigateBack({ delta: 1 });
          //   } else {
          //     this.$router.push("personal");
          //   }
          // }, 1200);
        }
      });
    },

    onFailed(errorInfo) {
      this.$toast(errorInfo.errors[0].message);
      this.showError = true;
    },
    afterRead(file) {
      // 将base64文件上传至服务器
      // this.headpic = "1";
      // console.log(file);
      let obj = {
        fileContent: file.content.split(",")[1],
      };
      uploadImageBase64(obj).then((res) => {
        this.setObj.headpic[0].url = res.content.path;
        this.onSubmit('uploadPic')
      });
    },
    shopInfo() {
      shopInfo({}).then((res) => {
        // console.log(res);
        this.minScope = res.content.minScope;
        let objs = {};
        objs.url = this.imgPrex + res.content.headpic;
        delete res.content.headpic;
        res.content.headpic = [];
        this.setObj = res.content;
        this.setObj.headpic.push(objs);

        // console.log(this.setObj);
      });
    },
    showTips() {
      this.$dialog
        .alert({
          message: "设置只针对同城订单",
        })
        .then(() => {
          // on close
        });
    },
    //
    beforeClose(action, done) {
      if (action === "confirm") {
        // console.log(this.$refs.submits);
        this.$refs.submits.submit();
        done(false);
      } else {
        this.shopInfo();
        done();
      }
    },
    // 编辑弹窗
    showEditPopup(val, type) {
      this.showEdit = true;
      // this.setObj={}
      this.editObj.name = val;
      // console.log(this.editObj.name)
      switch (type) {
        case 0:
          this.editObj.label = "店长名称";
          this.editObj.placeholder = this.editObj.message = "请输入店长名称";
          break;
        case 1:
          this.editObj.label = "店铺电话";
          this.editObj.placeholder = this.editObj.message = "请输入店铺电话";
          break;
        case 2:
          this.editObj.label = "提货地址";
          this.editObj.placeholder = this.editObj.message = "请输入提货地址";
          break;
        default:
          break;
      }
    },

    beforeRouteLeave(to, form, next) {
      if (this.$store.getters.ambientType == 0) {
        wx.miniProgram.navigateBack({ delta: 1 });
      } else {
        this.$router.push("personal");
      }
      next();
    },
  },
};
</script>
<style lang="scss" scoped>
.set {
  padding-bottom: 70px;
}
.btns {
  width: 355px;
  margin: auto auto 10px;
  .van-button {
    height: 50px;
    line-height: 50px;
    .van-button__text {
      font-size: 19px;
    }
  }
}

.van-cell {
  line-height: 30px;
  flex: 0 0 50px;
  overflow: visible;
}
// .van-cell:nth-child(7) {
//   margin-bottom: 150px;
// }
// .van-cell:nth-child(6) {
//   flex: none;
//   min-height: 50px;
// }
/deep/.van-field__left-icon {
  // margin-left: 60px !important;
  position: absolute;
  left: 130px;
  z-index: 99;
}
/deep/.van-field__label {
  width: auto !important;
  min-width: 80px;
}
.van-form {
  width: auto;
  height: calc(100% - 44px);
  display: flex;
  flex-flow: column;
}
/deep/.setUnload {
  width: 100%;
  height: 50px;
  .van-uploader__input-wrapper {
    width: 100%;
  }
  .van-uploader__input {
    width: 120px !important;
    position: absolute;
    right: 20px;
    left: auto;
    z-index: 3;
  }
  .van-uploader__preview {
    position: absolute;
    right: 28px;
    top: 5px;
    z-index: 2;
    .van-uploader__preview-image {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
    // .van-uploader__file{
    //   z-index: 8;
    // }
  }
  .van-field__control {
    // display: none;
    color: #fff;
  }
}

/deep/.van-dialog__content {
  .van-form {
    height: 100px;
    margin-top: 10px;
  }
  .van-cell {
    display: flex;
    flex-flow: column;
    align-items: center;
    height: 100%;
    overflow: visible;
    line-height: 32px;
    > div {
      // line-height: 40px;
      width: 80%;
    }
    .van-field__label {
      text-align: center;
    }
    .van-cell__value {
      border: 1.04px solid #d8d8d8;
      .van-field__control {
        padding: 4px 8px;
      }
    }
  }
}
.code {
  margin-top: 10px;
  padding: 16px 15px;
  background-color: #ffffff;
  .code-title {
    font-size: 15px;
    font-weight: 500;
    color: #333333;
  }
  .code-tips {
    margin-top: 5px;
    font-size: 12px;
    color: #999999;
  }
  .code-img {
    margin-top: 15px;
    text-align: center;
    img {
      width: 201px;
      height: 201px;
    }
  }
}
.save-btn {
  width: 355px;
  height: 50px;
  position: fixed;
  bottom: 10px;
  left: 0;
  right: 0;
  margin: 0 auto;
  color: #fff;
  font-size: 19px;
  font-weight: 800;
  background: linear-gradient(90deg, #fb6a4a 0%, #ff0808 100%);
  border-radius: 25px;
  z-index: 101;
}
</style>